import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class DrySystemsDto extends InspectionCase {
  manufacturerNameAndModel?: InspectionCase;
}

export class DrySystems extends DrySystemsDto {
  constructor(data: DrySystemsDto = { title: 'מערכות יבשות' }) {
    super(data);
    this.manufacturerNameAndModel = new InspectionCase({
      ...data.manufacturerNameAndModel,
      title: 'שם היצרן ודגם תחנת ההפעלה'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      !this.manufacturerNameAndModel.isApplicable ||
      this.manufacturerNameAndModel.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [...this.manufacturerNameAndModel.getNotes()];
  }
}
